import React from 'react';
import { Route } from 'react-router-dom';
import HotelList from '@features/hotels/components/HotelList';
import PortfolioDashboard from '@features/hotels/components/PortfolioDashboard';
import HotelDetails from '@features/hotels/components/HotelDetails';
import HotelOCRResults from '@features/hotels/components/HotelOCRResults';
import HotelCreationWizard from '@features/hotels/components/HotelCreationWizard';
import HotelFinancialsPage from '@pages/HotelFinancialsPage';
import ValuationAnalysisPage from '@pages/ValuationAnalysisPage';
import HotelSearchPage from '@pages/HotelSearchPage';
import { useParams } from 'react-router-dom';
import MainLayout from '@components/layout/MainLayout';
import ExtractionReviewPage from '@features/financialReview/ExtractionReviewPage';

// Wrapper component to pass route params to HotelFinancialsPage
const HotelFinancialsWrapper = () => {
  const { hotelId } = useParams<{ hotelId: string }>();
  return (
    <HotelFinancialsPage
      hotelId={hotelId || ''}
      yearsToShow={[new Date().getFullYear(), new Date().getFullYear() - 1, new Date().getFullYear() - 2]}
    />
  );
};

export const hotelRoutes = [
  <Route
    key="hotels"
    path="/hotels"
    element={
      <MainLayout>
        <PortfolioDashboard />
      </MainLayout>
    }
  />,
  <Route
    key="hotels-list"
    path="/hotels/list"
    element={
      <MainLayout>
        <HotelList />
      </MainLayout>
    }
  />,
  <Route
    key="hotel-search"
    path="/hotels/search"
    element={
      <MainLayout>
        <HotelSearchPage />
      </MainLayout>
    }
  />,
  <Route
    key="hotel-details"
    path="/hotels/:hotelId"
    element={
      <MainLayout>
        <HotelDetails />
      </MainLayout>
    }
  />,
  <Route
    key="hotel-financials"
    path="/hotels/:hotelId/edit-financials"
    element={
      <MainLayout>
        <HotelFinancialsWrapper />
      </MainLayout>
    }
  />,
  <Route
    key="hotel-valuation"
    path="/hotels/:hotelId/valuation"
    element={
      <MainLayout>
        <ValuationAnalysisPage />
      </MainLayout>
    }
  />,
  <Route
    key="add-hotel"
    path="/add-hotel"
    element={
      <MainLayout>
        <HotelCreationWizard />
      </MainLayout>
    }
  />,
  <Route
    key="hotel-ocr-results"
    path="/hotel-ocr-results"
    element={
      <MainLayout>
        <HotelOCRResults />
      </MainLayout>
    }
  />,
  <Route
    key="extraction-review"
    path="/hotels/:hotelId/financial-review/:fileId"
    element={
      <MainLayout>
        <ExtractionReviewPage />
      </MainLayout>
    }
  />
];

export default hotelRoutes;